import { createContext, ReactNode, useContext, useState } from "react"

type Panel = "fees" | "services"

const FilingSidebarAccordionContext = createContext<{
  openPanel: Panel | null
  setOpenPanel: (panel: Panel | null) => void
} | null>(null)

export function FilingSidebarAccordion({ children }: { children: ReactNode }) {
  const [openPanel, setOpenPanel] = useState<Panel | null>(null)

  return (
    <FilingSidebarAccordionContext.Provider value={{ openPanel, setOpenPanel }}>
      {children}
    </FilingSidebarAccordionContext.Provider>
  )
}

export function useFilingSidebarPanel(panel: Panel) {
  const context = useContext(FilingSidebarAccordionContext)
  const [localOpen, setLocalOpen] = useState(false)
  const open = context ? context.openPanel === panel : localOpen

  function toggle() {
    if (context) {
      context.setOpenPanel(open ? null : panel)
    } else {
      setLocalOpen((current) => !current)
    }
  }

  return [open, toggle] as const
}
